import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isFunction } from 'lodash-es';

import Checkbox from '../../CheckboxSet/components/Checkbox';

const takeIds = (items, itemKey) => {
  if (itemKey) {
    return isFunction(itemKey) ? items.map(itemKey) : items.map((item) => item[itemKey]);
  }
  return items;
};

const SelectableSubMenuLabel = ({
  label,
  selected,
  subMenus,
  selectedStateType = 'all',
  itemKey,
  disabled,
  onChange,
}) => {
  const selectedIds = takeIds(selected, itemKey);
  const subMenusIds = takeIds(subMenus, itemKey);

  const unselectedCount = new Set([...selectedIds, ...subMenusIds]).size - selectedIds.length;
  const allSelected = unselectedCount === 0;
  const anySelected = subMenusIds.length > unselectedCount;

  const isSelected = selectedStateType === 'all' ? allSelected : anySelected;
  const isIndeterminateState = anySelected && !isSelected;

  const handleSelection = (checked) => {
    const isItemKeyFunc = isFunction(itemKey);
    const takeItemKey = (item) => (isItemKeyFunc ? itemKey(item) : item[itemKey]);

    const withoutSubMenus = selected.filter((item) => {
      const id = itemKey ? takeItemKey(item) : item;
      return !subMenusIds.includes(id);
    });
    const nextSelected = checked ? withoutSubMenus.concat(subMenus) : withoutSubMenus;
    onChange(nextSelected);
  };

  return (
    <div className={cx('selectable-submenu-label', { disabled })}>
      <Checkbox
        id={label}
        checked={isSelected}
        disabled={disabled}
        indeterminate={isIndeterminateState}
        size="lg"
        withHoverEffect
        checkboxClassName="submenu-checkbox"
        onChange={handleSelection}
      />
      {label}
    </div>
  );
};

SelectableSubMenuLabel.propTypes = {
  label: T.node.isRequired,
  selected: T.array.isRequired,
  subMenus: T.array.isRequired, // Should have the same structure as `selected`
  selectedStateType: T.oneOf(['all', 'any']),
  itemKey: T.oneOfType([T.string, T.func]), // Should be used if `selected` is an array of objects
  disabled: T.bool,
  onChange: T.func.isRequired,
};

export default SelectableSubMenuLabel;
